module.exports = __webpack_public_path__ + "static/media/03_Cashanova-Cashpotsen.2cf6bae7.png";